import { render, staticRenderFns } from "./selectionUpload.vue?vue&type=template&id=567e62a3"
import script from "./selectionUpload.vue?vue&type=script&lang=js"
export * from "./selectionUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports